import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { WaremaButton } from '@warema/warema-ui-angular';

@Component({
    selector: 'warema-tab-header',
    imports: [TranslatePipe, WaremaButton],
    templateUrl: './tab-header.component.html',
    styleUrls: ['./tab-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabHeaderComponent {
    public readonly titleKey = input('');

    public readonly subtitleKey = input('');

    public readonly subtitleKeyInnerHtml = input('');

    public readonly hasAction = input(false);

    public readonly actionTextKey = input('');

    public readonly actionRedirectUrl = input('');

    public readonly isRedirectOnNewTab = input(false);

    public readonly isButtonSmall = input(false);

    public readonly buttonId = input('');

    public readonly iconRight = input('');

    public readonly iconLeft = input('');
}
